import { createSlice } from "@reduxjs/toolkit";
import { RESET } from "../types";
import { createTransform } from "redux-persist";

const initialState = {
  alignment: "orders",
  mapViewState: "map",
  isFullScreen: false,
  playOrderAlert: false,
};

export const dashboardTransform = createTransform(
  // Serialize state before persisting
  (inboundState) => ({
    alignment: inboundState.alignment,
    mapViewState: inboundState.mapViewState,
    isFullScreen: inboundState.isFullScreen,
  }),
  // Deserialize state when rehydrating — merge with initialState for missing keys
  (outboundState) => ({
    ...initialState,
    ...outboundState,
  }),
  { whitelist: ["dashboard"] }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setIsFullscreen: (state, action) => {
      state.isFullScreen = action.payload;
    },
    setAlignment: (state, action) => {
      state.alignment = action.payload;
    },
    setMapViewState: (state, action) => {
      state.mapViewState = action.payload;
    },
    setShowAutoAcceptOrders(state, action) {
      state.showAutoAcceptOrders = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(RESET, () => initialState);
  },
});

export const {
  setIsFullscreen,
  setAlignment,
  setMapViewState,
  setShowAutoAcceptOrders,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
